<template>
  <card class="card" title="Dados da Movimentação do Carro">
    <div>
      <form @submit.prevent="createCarTransfer">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Placa do veículo</label>
              <select v-model="carTransfer.carId" class="form-control input i-width" required>
                <option :value="null" selected>Selecione...</option>
                <option v-for="car in cars" :key="car.id" :value="car.id">{{ car.plate }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Nome do motorista</label>
              <select v-model="carTransfer.driverId" class="form-control input i-width" required>
                <option :value="null" selected>Selecione...</option>
                <option v-for="driver in drivers" :key="driver.id" :value="driver.id">{{ driver.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="file"
              multiple
              label="Adicionar fotos"
              accept="image/png, image/jpeg"
              @change="onFileChange"
              required
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              type="number"
              label="KM do veículo"
              placeholder="Digite a km do veículo."
              v-model="carTransfer.mileage"
              required
            ></fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Descrição</label>
              <textarea
                rows="5"
                class="form-control border-input"
                placeholder="Digite aqui o motivo da movimentação do carro..."
                v-model="carTransfer.description"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn-custom btn-cobranca mb-3">Cadastrar</button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  computed: {
    cars() {
      return this.$store.getters.cars;
    },
    drivers() {
      return this.$store.getters.drivers;
    }
  },
  data() {
    return {
      carTransfer: {
        carId: null,
        driverId: null,
        mileage: null,
        description: '',
        images: [],
      }
    }
  },
  methods: {
    ...mapActions(["fetchCars", "fetchDrivers", "addCarTransfer"]),
    onFileChange(e) {
      this.carTransfer.images = [];
      this.carTransfer.images = e.target.files;
    },
    async createCarTransfer() {
      try {
        const formData = new FormData();

        for( var i = 0; i < this.carTransfer.images.length; i++ ){
          const file = this.carTransfer.images[i];
          formData.append('files', file);
        }

        formData.append('carId', this.carTransfer.carId);
        formData.append('driverId', this.carTransfer.driverId);
        formData.append('mileage', this.carTransfer.mileage);
        formData.append('description', this.carTransfer.description);

        await this.addCarTransfer({ body: formData });
        Swal.fire("Sucesso!", "Transferência criada com sucesso", "success");
        this.$router.push("/movimentacao-carros");
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível criar a transferência", "error");
      }
    },
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchCars({ perPage: 100 }),
        this.fetchDrivers({ perPage: 100 }),
      ]);
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar as informações", "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }
}
</style>